import { render, staticRenderFns } from "./RestDialog.vue?vue&type=template&id=61e3ba98&scoped=true"
import script from "./RestDialog.vue?vue&type=script&lang=js"
export * from "./RestDialog.vue?vue&type=script&lang=js"
import style0 from "./RestDialog.vue?vue&type=style&index=0&id=61e3ba98&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61e3ba98",
  null
  
)

export default component.exports